<div class="flex center margin-bottom padding-right-small topbar">
  @if(titleData && !titleData.title){
    <ng-container>
      <div class="flex-1 search-bar">
        <input type="text"
               class="full-width"
               [id]="searchInputId"
               [placeholder]="titleData.placeholder"
               [(ngModel)]="searchText.parent"
               (blur)="onBlurSearch()" />
               @if(!!searchText.parent){
                 <i class="fa fa-times"
                    (click)="onClearSearch()"></i>
               }
      </div>
      <div class="flex-0 margin-left">
        <button (click)="onSearch()"><i class="fa fa-search"></i>Search</button>
      </div>
    </ng-container>
  }
  @if(titleData && !!titleData.title){
    <h3 class="flex-1 flex center padding-left-small">
      {{titleData.title}}
    </h3>
  }
  <!-- <div class="flex-0 nowrap padding-left hover">
    <div class="flex center">
      <div class="flex-0 padding-small"><i class="fa fa-bell"></i></div>
      <div class="flex-1">Notifications</div>
    </div>
  </div>
  <div class="flex-0 nowrap padding-left">
    <div class="flex center"
         [ngClass]="{'hover': !showUserMenu}"
         (click)="showUserMenu = !showUserMenu">
      <bt-menu [show]="showUserMenu"
               [iconName]="'fa-user-circle'"
               [right]="-55"
               (hidden)="showUserMenu = false"
               (showed)="showUserMenu = true">
        <div class="width padding-small">
          <div class="flex vertical center">
            <div class="thumbnail margin-bottom-small"
                 style="background: url(https://via.placeholder.com/150);"></div>
            <h4>{{userName}}</h4>
            <div class="margin-top-x-small margin-bottom">Role</div>
            <button class="margin-bottom-small"><i class="fa fa-sign-out"></i>Logout</button>
            <button class="warning"><i class="fa fa-trash"></i>Delete account</button>
          </div>
        </div>
      </bt-menu>
      <div class="flex-1 action-menu">{{userName}}</div>
    </div>
  </div> -->
</div>
